const videoPlayButtonSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="110.686px" height="115.056px" viewBox="0 0 110.686 115.056" enable-background="new 0 0 110.686 115.056"
	 xml:space="preserve">
<g id="Layer_1">
	<g>
		<polygon fill="#14ACE3" points="42.93,85.929 78.673,57.526 42.93,29.125 		"/>
		<path fill="#14ACE3" d="M55.343,0C24.827,0,0,25.809,0,57.526c0,31.72,24.827,57.529,55.343,57.529
			c30.517,0,55.343-25.81,55.343-57.529C110.686,25.809,85.86,0,55.343,0z M55.343,110.063c-27.869,0-50.54-23.564-50.54-52.536
			c0-28.966,22.671-52.532,50.54-52.532s50.541,23.566,50.541,52.532C105.884,86.498,83.211,110.063,55.343,110.063z"/>
	</g>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
</g>
</svg>
`;


export default videoPlayButtonSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/videoPlayButtonSVG.js